export default __webpack_public_path__ + "static/media/Modal_Logo.c8ddc72a.svg";